function randomBetween(min, max) {
  return Math.random() * (max - min) + min
}

class PopSpirit {
  constructor({ size, color, canvas }) {
    this.canvas = canvas

    // 基于左上角的位置
    this.x = randomBetween(0, canvas.width)
    this.y = randomBetween(0, canvas.height)

    this.size = size
    this.color = color

    this.resetSpeed()
  }

  resetSpeed() {
    // x的速度和y的速度
    this.vx = randomBetween(-10, 10) * 0.1
    this.vy = randomBetween(-10, -5) * 0.1
  }

  update() {
    const { canvas } = this
    const centerX = canvas.width / 2

    this.x += this.vx
    this.y += this.vy

    if (this.x > canvas.width || this.x < 0 || this.y > canvas.height || this.y < 0) {

      // 重置气泡位置，接近画布底部中心
      this.x = centerX + randomBetween(-centerX, centerX) * 0.5
      this.y = canvas.height

      this.resetSpeed()
    }

  }

  draw(context) {

    if (!context) {
      throw new ReferenceError('not context')
    }

    const gradient = context.createRadialGradient(0, 0, 0, 0, 0, this.size)
    gradient.addColorStop(0, "rgba(255,255,255,1)")
    gradient.addColorStop(1, "rgba(0,240,255,0.1)")

    context.save()
    context.fillStyle = gradient
    context.translate(this.x, this.y)
    context.beginPath()
    context.arc(0, 0, this.size, 0, Math.PI * 2, true)
    context.closePath()
    context.fill()
    context.restore()
  }
}


class PopManager {
  constructor(canvas) {

    this.canvas = canvas
    // 气泡总数
    this.popNum = 20
    this.pops = []

    this.setup()
  }

  setup() {
    const { canvas } = this

    for (let i = 0; i < this.popNum; i++) {

      const randomColor = '#' + parseInt(0xffffff * Math.random()).toString(16)

      const pop = new PopSpirit({
        canvas: canvas,
        size: randomBetween(0, 3),
        color: randomColor,
      })

      this.pops.push(pop)
    }
  }

  update() {
    this.pops.forEach(pop => {
      pop.update()
    })
  }

  draw(context, cx, cy) {
    this.pops.forEach(pop => {
      pop.draw(context, cx, cy)
    })
  }
}



export { PopManager }
